import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "list-group-item" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "col fw-bold text-dark" }
const _hoisted_5 = { class: "col-auto" }
const _hoisted_6 = {
  key: 0,
  class: "fas fa-check-circle text-primary"
}
const _hoisted_7 = {
  key: 1,
  class: "far fa-circle text-muted"
}
const _hoisted_8 = { class: "row align-items-center mt-2" }
const _hoisted_9 = { class: "col" }

import { ICardInfo } from '@/interfaces';
import CardInfoContainer from './CardInfoContainer.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'CardListItem',
  props: {
    card: {},
    selected: { type: Boolean }
  },
  emits: ["onRemove", "onSelect"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "row align-items-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onSelect')))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-credit-card me-2" }, null, -1)),
            _createVNode(CardInfoContainer, { info: _ctx.card }, null, 8, ["info"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.selected)
              ? (_openBlock(), _createElementBlock("i", _hoisted_6))
              : (_openBlock(), _createElementBlock("i", _hoisted_7))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn btn-link text-muted ps-0 pb-0",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('onRemove')))
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fas fa-trash-alt me-1" }, null, -1),
              _createTextVNode(" Remover ")
            ]))
          ])
        ])
      ])
    ])
  ]))
}
}

})